// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popover-content[data-v-0427e5f0]{\n  padding: 1rem;\n  background-color: hsl(var(--o-popover));\n  color: hsl(var(--o-popover-foreground));\n  border-color: hsl(var(--o-border));\n  z-index: 1002;\n  overflow: hidden;\n  border-radius: 0.375rem/* 6px */;\n  border-width: 1px;\n  --o-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  box-shadow: var(--o-ring-offset-shadow, 0 0 #0000), var(--o-ring-shadow, 0 0 #0000), var(--o-shadow);\n}\n\n", ""]);
// Exports
module.exports = exports;
